import authActionTypes from "containers/Auth/_actions";
import appActionTypes from "containers/App/_actions";
import { fetchFarmAccess } from "containers/Farm/_actions";
import * as api from "api";
import ReactGA from "react-ga4";

const actionTypes = {
    DAHSBOARD_GET_MY_USER_INVITATIONS: "DAHSBOARD_GET_MY_USER_INVITATIONS",
    DAHSBOARD_GET_MY_USER_INVITATIONS_SUCCESS: "DAHSBOARD_GET_MY_USER_INVITATIONS_SUCCESS",
    DAHSBOARD_GET_MY_USER_INVITATIONS_FAILURE: "DAHSBOARD_GET_MY_USER_INVITATIONS_FAILURE",
    DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS: "DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS",
    DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_SUCCESS: "DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_SUCCESS",
    DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_FAILURE: "DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_FAILURE",
    DAHSBOARD_GET_ACCESS_INVITATIONS: "DAHSBOARD_GET_ACCESS_INVITATIONS",
    DAHSBOARD_GET_ACCESS_INVITATIONS_SUCCESS: "DAHSBOARD_GET_ACCESS_INVITATIONS_SUCCESS",
    DAHSBOARD_GET_ACCESS_INVITATIONS_FAILURE: "DAHSBOARD_GET_ACCESS_INVITATIONS_FAILURE",
    DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS: "DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS",
    DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_SUCCESS: "DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_SUCCESS",
    DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_FAILURE: "DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_FAILURE",
    DAHSBOARD_GET_MY_FARMS: "DAHSBOARD_GET_MY_FARMS",
    DAHSBOARD_GET_MY_FARMS_SUCCESS: "DAHSBOARD_GET_MY_FARMS_SUCCESS",
    DAHSBOARD_GET_MY_FARMS_FAILURE: "DAHSBOARD_GET_MY_FARMS_FAILURE",
    DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY: "DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY",
    DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_SUCCESS: "DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_SUCCESS",
    DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_FAILURE: "DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_FAILURE",
    DAHSBOARD_GET_MY_RECENT_PUBLICATIONS: "DAHSBOARD_GET_MY_RECENT_PUBLICATIONS",
    DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_SUCCESS: "DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_SUCCESS",
    DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_FAILURE: "DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_FAILURE",
    DAHSBOARD_GET_MY_FARM_GROUPS: "DAHSBOARD_GET_MY_FARM_GROUPS",
    DAHSBOARD_GET_MY_FARM_GROUPS_SUCCESS: "DAHSBOARD_GET_MY_FARM_GROUPS_SUCCESS",
    DAHSBOARD_GET_MY_FARM_GROUPS_FAILURE: "DAHSBOARD_GET_MY_FARM_GROUPS_FAILURE",
    DAHSBOARD_GET_MY_ANNOUNCEMENTS: "DAHSBOARD_GET_MY_ANNOUNCEMENTS",
    DAHSBOARD_GET_MY_ANNOUNCEMENTS_SUCCESS: "DAHSBOARD_GET_MY_ANNOUNCEMENTS_SUCCESS",
    DAHSBOARD_GET_MY_ANNOUNCEMENTS_FAILURE: "DAHSBOARD_GET_MY_ANNOUNCEMENTS_FAILURE",
    DAHSBOARD_DISMISS_ANNOUNCEMENT_SUCCESS: "DAHSBOARD_DISMISS_ANNOUNCEMENT_SUCCESS",
    DAHSBOARD_GET_MY_FARM_GROUP_INVITES: "DAHSBOARD_GET_MY_FARM_GROUP_INVITES",
    DAHSBOARD_GET_MY_FARM_GROUP_INVITES_SUCCESS: "DAHSBOARD_GET_MY_FARM_GROUP_INVITES_SUCCESS",
    DAHSBOARD_GET_MY_FARM_GROUP_INVITES_FAILURE: "DAHSBOARD_GET_MY_FARM_GROUP_INVITES_FAILURE",
    DAHSBOARD_CANCEL: "DAHSBOARD_CANCEL",
};
export default actionTypes;

// Cancel
export function cancel() {
    return (dispatch) => {
        dispatch({ type: actionTypes.DAHSBOARD_CANCEL });
        dispatch({ type: appActionTypes.APP_CLOSE_MODAL });
    };
}

// Reload Dashboard
export const reloadDashboard = () => {
    return (dispatch) => {
        dispatch({ type: appActionTypes.APP_CLOSE_MODAL });
        dispatch(getMyUserInvitations());
        dispatch(getMyFarmAccessInvitations());
        dispatch(getMyFarmAccessRequests());
        dispatch(getMyFarms());
        if (process.env.REACT_APP_DISABLE_FARM_GROUPS !== "true") {
            dispatch(getMyFarmGroups());
            dispatch(getMyPublicationsSummary());
            dispatch(getMyRecentPublications());
        }
    };
};

// My Announcements
export function getMyAnnouncements() {
    return api.get({
        path: `messages`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_ANNOUNCEMENTS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

export function dismissAnnouncement(id) {
    return api.put({
        path: `messages/${id}/dismiss`,
        onSuccess: () => {
            return { type: actionTypes.DAHSBOARD_DISMISS_ANNOUNCEMENT_SUCCESS, payload: id };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My User Invitations
export function getMyUserInvitations() {
    return api.get({
        path: `invitations`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_USER_INVITATIONS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// Invitations sent by me for all farms
export function getAccessInvitations() {
    return api.get({
        path: `accessInvitations`,
        silentMode: true,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_ACCESS_INVITATIONS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Farm Access Invitations
export function getMyFarmAccessInvitations() {
    return api.get({
        path: `farmAccessInvitations`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_INVITATIONS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Farm Access Requets
export function getMyFarmAccessRequests() {
    return api.get({
        path: `farmAccessRequests`,
        silentMode: true,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_ACCESS_REQUESTS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Farms
export function getMyFarms() {
    return api.get({
        path: `farms`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARMS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARMS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_FARMS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Publications Summary
export function getMyPublicationsSummary() {
    return api.get({
        path: `publications/summary`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_PUBLICATIONS_SUMMARY_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Recent Publications
export function getMyRecentPublications() {
    const searchDate = new Date();
    searchDate.setDate(searchDate.getDate() - 7);

    return api.get({
        path: `publications/search?searchText=${searchDate.toLocaleDateString("en-NZ")}`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_RECENT_PUBLICATIONS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_RECENT_PUBLICATIONS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// My Farm Groups
export function getMyFarmGroups() {
    return api.get({
        path: `farmGroups`,
        onBeforeSend: () => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS };
        },
        onSuccess: (response) => {
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS_SUCCESS, payload: response };
        },
        onFailure: (error) => {
            error.handled = true;
            return { type: actionTypes.DAHSBOARD_GET_MY_FARM_GROUPS_FAILURE };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

// Withdraw My Farm Access Request
export function withdrawFarmAccessRequest(accessRequest) {
    ReactGA.event({
        category: "Farm Access Request",
        action: "Withdraw",
    });
    return api.del({
        path: `farmAccessRequests/${accessRequest.id}`,
        onSuccess: (response) => {
            return (dispatch) => {
                dispatch({ type: appActionTypes.APP_CLOSE_MODAL });
                dispatch(getMyFarmAccessRequests());
            };
        },
        onFailure: (error) => {
            error.handled = true;
            return (dispatch) => {
                switch (error.status) {
                    case 403:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: `You are not authorised to withdraw this access request.` });
                        break;
                    default:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "An unexpected error has occured. Please try again or call support if the problem persists." });
                        break;
                }
            };
        },
    });
}

export function resendFarmAccessRequest(accessRequest) {
    ReactGA.event({
        category: "Farm Access Request",
        action: "Resend",
    });
    return api.put({
        path: `farmAccessRequests/${accessRequest.id}/resend`,
        content: accessRequest,
        onSuccess: (response) => {
            return (dispatch) => {
                dispatch(getMyFarmAccessRequests());
                dispatch({ type: appActionTypes.APP_CLOSE_MODAL });
            };
        },
        onFailure: (error) => {
            error.handled = true;
            return (dispatch) => {
                switch (error.status) {
                    case 403:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: `You are not authorised to resend this access request.` });
                        break;
                    case 404:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "This access request is no longer valid." });
                        break;
                    default:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "An unexpected error has occured. Please try again or call support if the problem persists." });
                        break;
                }
                dispatch(getMyFarmAccessRequests());
            };
        },
        cancelActionType: actionTypes.DAHSBOARD_CANCEL,
    });
}

export const acceptOrgInvitation = (invitation) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "User Invitation",
            action: "Accept",
        });
        return dispatch(
            api.put({
                path: `invitations/${invitation.id}/accept`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch({ type: authActionTypes.AUTH_CLEAR_STORAGE });
                        dispatch({ type: authActionTypes.AUTH_LOGOUT });
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("Invalid credentials. Please try again.");
                            break;
                        case 404:
                            reject("This invitation is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const declineOrgInvitation = (invitation) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "User Invitation",
            action: "Decline",
        });
        return dispatch(
            api.put({
                path: `invitations/${invitation.id}/decline`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch(getMyUserInvitations());
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("Invalid credentials. Please try again.");
                            break;
                        case 404:
                            reject("This invitation is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const acceptFarmAccessRequest = (accessRequest) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Access Request",
            action: "Accept",
        });
        return dispatch(
            api.put({
                path: `farmAccessRequests/${accessRequest.id}/accept`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch(getMyFarmAccessRequests());
                        dispatch(fetchFarmAccess(accessRequest.farmId));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("You are not authorised to accept this access request.");
                            break;
                        case 404:
                            reject("This access request is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const declineFarmAccessRequest = (accessRequest) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Access Request",
            action: "Decline",
        });
        return dispatch(
            api.put({
                path: `farmAccessRequests/${accessRequest.id}/decline`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch(getMyFarmAccessRequests());
                        dispatch(fetchFarmAccess(accessRequest.farmId));
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("You are not authorised to decline this access request.");
                            break;
                        case 404:
                            reject("This access request is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const acceptFarmOwnership = (nomination) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Access Invitation",
            action: "Accept",
        });
        return dispatch(
            api.put({
                path: `farmAccessInvitations/${nomination.id}/accept`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch(getMyFarmAccessInvitations());
                        dispatch(getMyFarms());
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("You are not authorised to accept this nomination.");
                            break;
                        case 404:
                            reject("This nomination is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const declineFarmOwnership = (nomination) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Access Invitation",
            action: "Decline",
        });
        return dispatch(
            api.put({
                path: `farmAccessInvitations/${nomination.id}/decline`,
                onSuccess: () => {
                    resolve();
                    return (dispatch) => {
                        dispatch(getMyFarmAccessInvitations());
                        dispatch(getMyFarms());
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    switch (error.status) {
                        case 403:
                            reject("You are not authorised to decline this nomination.");
                            break;
                        case 404:
                            reject("This nomination is no longer valid.");
                            break;
                        default:
                            reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                            break;
                    }
                    return [];
                },
            })
        );
    });
};

export const createFarmGroup = (farmGroup) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Group",
            action: "Create",
        });
        return dispatch(
            api.post({
                path: `farmGroups`,
                content: farmGroup,
                onSuccess: (response) => {
                    resolve(response);
                    return (dispatch) => {
                        dispatch(getMyFarmGroups());
                    };
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured.Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const findFarms = (searchText) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Farm Group",
            action: "Farm Search",
        });
        const encodedSearchText = encodeURIComponent(searchText);
        return dispatch(
            api.get({
                path: `search/farms?searchText=${encodedSearchText}&filterBy=AllFarms`,
                debounceTime: 500,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject(error);
                    return [];
                },
            })
        );
    });
};
